import { RVHeaderInputFilterCount, RVButton, RVNestedPageHeader } from "@regal-voice/ui";
import { SavedViews } from "Components/shared/SavedViews/SavedViews";
import { ToggleCollapsiblePanelButton, useKnownPanels } from "Utils/CollapsiblePanels";

import type { QueryParams } from "@regal-voice/ui";

type JourneysHeaderProps = {
    linkToJourneyBuilder: () => void;
    defaultSearch: string;
    filtersCount: number;
    setFilterValue: (value: string) => void;
    baseParams: Partial<QueryParams>;
};

export default function JourneysHeader({
    linkToJourneyBuilder,
    defaultSearch,
    filtersCount,
    setFilterValue,
    baseParams,
}: JourneysHeaderProps) {
    const { orchestration: journeysPanel } = useKnownPanels();

    return (
        <div>
            <RVNestedPageHeader
                title="Journeys"
                prefix={<ToggleCollapsiblePanelButton panelName={journeysPanel.name} direction="left" />}
                titleRowActions={<SavedViews name="Journeys" baseParams={baseParams} />}
                actionRowLeft={
                    <RVHeaderInputFilterCount
                        setFilterValue={setFilterValue}
                        defaultSearch={defaultSearch}
                        count={filtersCount}
                        placeholder="Search by Journey Name or ID"
                    />
                }
                actionRowRight={
                    <RVButton
                        role="link"
                        size="large"
                        type="primary"
                        icon="add-circle-outline"
                        onClick={linkToJourneyBuilder}
                    >
                        New Journey
                    </RVButton>
                }
            />
        </div>
    );
}
